let debug: boolean = false;

export function getDebugMode() {
    return debug;
}

export function setDebugMode(debugMode: boolean) {
    debug = debugMode;
}
